export default "__VITE_ASSET__RLDxb3FR__"